const getFileFromBase64 = (base64String: string, fileName: string, mimeType: string): File => {
  const base64Data = base64String.includes(',') ? base64String.split(',')[1] : base64String;
  const byteCharacters = atob(base64Data);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType });
  const file = new File([blob], fileName, { type: mimeType });
  return file;
};

const mimeToExtension: Record<string, string> = {
  'application/pdf': 'pdf',
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'text/plain': 'txt',
  'text/html': 'html',
  'text/csv': 'csv',
  'application/json': 'json',
  'application/xml': 'xml',
  'application/zip': 'zip',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx'
};

const appendExtension = (name: string, mimeType: string): string => {
  const ext = mimeToExtension[mimeType];
  if (!ext) return name;

  if (name.endsWith(`.${ext}`)) return name;

  return `${name}.${ext}`;
};

const FileUtils = {
  getFileFromBase64,
  appendExtension
};

export default FileUtils;
